import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { AppFeatures } from '@urbanx/agx-ui-components'
import { GetFeatureToggles } from 'services'
import { AuthContext } from '@urbanx/agx.auth.client'
import { useContext } from 'react'

const useFeatureToggles = (): {
  featureToggles?: AppFeatures
  isLoading: boolean
  isFetched: boolean
} => {
  const { campaignId } = useParams()
  const { getAuthToken } = useContext(AuthContext)
  const featureTogglesQueryKey = ['feature-toggles', campaignId]

  const {
    data: featureToggles,
    isLoading,
    isFetched,
  } = useQuery<AppFeatures | undefined>({
    queryKey: featureTogglesQueryKey,
    queryFn: (ctx) =>
      GetFeatureToggles(getAuthToken, ctx.queryKey[1] as string),
    enabled: !!campaignId,
  })

  return {
    featureToggles,
    isLoading,
    isFetched,
  }
}

export default useFeatureToggles
